<div class="d-flex pt-2 form-element">
  @if (props?.label) {
    <label>
      <span>{{ props.label }}</span>
    </label>
  }

  @if (props.options$ | async; as options) {
    <div class="p-field-radiobutton">
      @for (option of options; track option) {
        <div class="p-field-checkbox">
          <p-radioButton
            [value]="option[props.value_key]"
            [(ngModel)]="selectedValue"
            [formControl]="formControl"
            [inputId]="option[props.value_key]"
            [name]="key">
          </p-radioButton>
          <label [for]="option[props.value_key]">{{ option[props.label_key] }}</label>
        </div>
      }
    </div>
  }

  @if (formControl) {
    <cap-validator [control]="formControl" [customName]="props.label"></cap-validator>
  }
</div>
